let scriptPromise = null;
let preloadScheduled = false;

// Memoized: repeated calls (one per form on the page) share the same
// in-flight/loaded script instead of injecting it multiple times.
export function loadRecaptchaScript(siteKey) {
  if (typeof window === 'undefined' || !siteKey) return Promise.resolve(false);
  if (window.grecaptcha) return Promise.resolve(true);

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      const existing = document.querySelector('script[data-recaptcha-loader]');
      if (existing) {
        existing.addEventListener('load', () => resolve(true));
        existing.addEventListener('error', () => resolve(false));
        return;
      }

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      script.dataset.recaptchaLoader = 'true';
      script.addEventListener('load', () => resolve(true));
      script.addEventListener('error', () => resolve(false));
      document.head.appendChild(script);
    });
  }

  return scriptPromise;
}

// reCAPTCHA is needed on nearly every page (footer contact form), but
// loading it immediately competes with initial paint. Instead we load it
// as soon as the page goes idle or the user first interacts — well before
// anyone could realistically fill out and submit a form — and each form's
// own getCaptchaToken() still awaits loadRecaptchaScript() directly as a
// fallback, so a submit can never silently skip the captcha.
export function scheduleRecaptchaPreload(siteKey) {
  if (preloadScheduled || typeof window === 'undefined' || !siteKey) return;
  preloadScheduled = true;

  const load = () => loadRecaptchaScript(siteKey);

  const interactionEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  const onInteraction = () => {
    interactionEvents.forEach((e) => window.removeEventListener(e, onInteraction));
    load();
  };
  interactionEvents.forEach((e) =>
    window.addEventListener(e, onInteraction, { once: true, passive: true }),
  );

  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 3000));
  idle(load, { timeout: 5000 });
}
